import Main, {
  axios,
  setPromise,
  getEndpoint,
  omitId
} from './main'

export {
  APIURI,
  client_secret,
  client_id,
  getFirstErrorMessage,
  getErrorMessage,
  getErrorMessages,
  getErrorMessagesWithKeys,
  endpoints,
  services,
  handlePromise,
  promise,
  setPromise,
  getEndpoint
} from './main'

export const getMyOrders = async (payload, options = {}) => {
  const endPoint = getEndpoint('user.orders.get', {}, '/customer/order', options)
  const {data} = await axios.get(endPoint, {params: omitId(payload)})
  return data
}
setPromise('user.orders.get', getMyOrders)

export const getMySubscriptions = async (options = {}) => {
  const endPoint = getEndpoint('user.subscriptions.get', {}, '/customer/subscription', options)
  const {data} = await axios.get(endPoint)
  return data
}
setPromise('user.subscriptions.get', getMySubscriptions)

export const cancelMySubscription = async (id, options = {}) => {
  const endPoint = getEndpoint('user.subscription.cancel', {id}, '/customer/subscription/{id}/cancel', options)
  const {data} = await axios.post(endPoint)
  return data
}
setPromise('user.subscription.cancel', cancelMySubscription)

export const updateMySubscriptionPaymentMethod = async (id, payload, options = {}) => {
  const endPoint = getEndpoint('user.subscription.paymentMethod.update', {id}, '/customer/subscription/{id}/updatePaymentMethod', options)
  const {data} = await axios.post(endPoint, payload)
  return data
}
setPromise('user.subscription.paymentMethod.update', updateMySubscriptionPaymentMethod)

const myServices = {getMyOrders, getMySubscriptions}

export default {
  ...Main,
  ...myServices
}
